import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { updateToken } from '../actions/login.action'
import { PROFILE, RETOKEN, TOKEN } from '../Constants'
import { loginLarkAPI, loginLarkCallbackAPI } from '../services/login'
import Error_false from '../components/error/error-false'
import { updateRole } from '../actions/role-org.action'
import { MENU_LOGIN } from '../router/routes'
import fnMapMenu from '../components/layouts/Menu/map-1-menu'
import SwalCustom from '../alert/swal-custom'
import { useLanguageStage } from '../store/layout'
import { updateAllMenu } from '../actions/allMenu.action'

function LoginLarkPage() {
  let [searchParams] = useSearchParams()
  const [isLogin, setIsLogin] = React.useState(true)
  const dispatch = useDispatch()

  let { appId } = useParams()
  const code = searchParams.get('code')
  const reDirect = searchParams.get('go')
  const navigate = useNavigate()
  const { setLanguageStage } = useLanguageStage()

  useEffect(() => {
    if (!code) {
      localStorage.setItem('redirect', reDirect ?? '')
    }
  }, [code, reDirect])

  useEffect(() => {
    const fnLoginLark = async () => {
      try {
        const resp = await loginLarkAPI({ appId })
        if (!resp) return
        if (resp.status) {
          setTimeout(() => {
            resp.result?.url && window.open(resp.result?.url, '_self')
          }, 1000)
        } else {
          Error_false({ msg: resp.error }).then(() => {
            navigate(MENU_LOGIN)
          })
        }
      } catch (error) {
        Error_false({ msg: error?.toString() }).then(() => {
          navigate(MENU_LOGIN)
        })
      }
    }
    if (code) {
      loginLarkCallback()
    } else {
      fnLoginLark()
    }
  }, [code])

  const loginLarkCallback = async () => {
    setIsLogin(true)
    const result = await loginLarkCallbackAPI({ code, appId })
    if (!result) return
    setTimeout(() => {
      saveDataLocal(result)
    }, 1000)
  }

  const saveDataLocal = (res) => {
    if (res.status) {
      const profile = res.result[0]
      localStorage.setItem(RETOKEN, res.refreshToken)
      localStorage.setItem(TOKEN, res.accessToken)
      localStorage.setItem(PROFILE, JSON.stringify(res.result[0]))
      setLanguageStage('en')

      const menu = res.result[0]?.role_menus.map((d) => fnMapMenu(d))
      const menuLength = menu.filter((item) => item)

      dispatch(updateToken(res.accessToken, res.refreshToken, res.result[0]))
      dispatch(
        updateRole(profile.roles.length > 0 ? profile.roles[0].org_id : 0)
      )
      dispatch(updateAllMenu(menuLength))
      let redi = localStorage.getItem('redirect') || ''

      if (menuLength.length > 0) {
        if (redi) {
          navigate(redi)
        } else {
          navigate('/')
        }
      } else {
        SwalCustom({
          title: `Menu Error`,
          text: 'โปรดตรวจสอบสิทธิการเข้าถึง หรือ ติดต่อ Line OA แผนกไอที',
          confirmButtonColor: '#ffc107'
        }).then(() => {
          navigate(MENU_LOGIN)
        })
      }
    } else {
      Error_false(res).then(() => {
        navigate(MENU_LOGIN)
      })
    }
    setIsLogin(false)
  }

  return (
    <div
      className="d-xl-flex align-items-xl-center"
      style={{
        height: '100vh'
      }}
    >
      {isLogin && <div className="preloader-login"></div>}
    </div>
  )
}

export default LoginLarkPage
